import type { AnchorHTMLAttributes, Ref } from 'react';
import { Link } from 'react-router';

type Props = AnchorHTMLAttributes<HTMLAnchorElement> & { href?: string; ref?: Ref<HTMLAnchorElement> };

/** Astryx LinkProvider adapter: in-app hrefs go through React Router, others stay plain anchors. */
export function RouterLink({ href = '', ref, ...rest }: Props) {
  const external = /^(https?:|mailto:|tel:|blob:)/.test(href) || rest.target === '_blank' || rest.download !== undefined;
  if (external) return <a href={href} ref={ref} {...rest} />;
  return <Link to={href} ref={ref} {...rest} />;
}
